import React from 'react';

import BaseButton from 'components/base-button';
import { MessageIcon } from 'components/icons-new/message';

import { useNotificationsCtx } from '../../model';
import { useIsUserHaveRole } from '@/hooks/use-is-user-have-role';
import { USER_ROLES } from '@/constants';

const NotificationsDrawerTrigger = () => {
  const {
    drawer: { isOpen },
    hasUnreadNotifications,
    openAllNotifications,
    closeNotifications,
    registerTrigger
  } = useNotificationsCtx();

  const canSeeNotifications = useIsUserHaveRole([
    USER_ROLES.fleetManager.id,
    USER_ROLES.administrator.id,
    USER_ROLES.mobexoEmployee.id
  ]);

  const handleClick = () => {
    if (isOpen) {
      closeNotifications();
    } else {
      openAllNotifications();
    }
  };

  const triggerRef = (element: HTMLButtonElement | null) => {
    registerTrigger(element);
  };

  if (!canSeeNotifications) {
    return null;
  }

  return (
    <BaseButton ref={triggerRef} icon variant='tertiary' onClick={handleClick}>
      <MessageIcon hovered={isOpen} color='currentColor' {...(hasUnreadNotifications && { color: '#BF0040' })} />
    </BaseButton>
  );
};

export default NotificationsDrawerTrigger;
